
<app-bread-crumb [items]="[{text:'clubes'}]" [sectionTitle]="'Lista de Clubes'"></app-bread-crumb>

<section class="content">
  <div class="row">
    <div class="col-md-12">

      <!-- inicio do box -->
      <ng-box [boxIcon]="'fa fa-soccer-ball-o'" [boxTitle]="'Clubes'">

        <!-- cabesalho do box -->
        <ng-container class="ng-box-header">
          <ng-button
          *ngIf="isAdminOrUserKhuzela()"
          (click)="create()"
          [button]="{name:'novo clube', faIconClass:'fa fa-plus',color:'danger'}">
        </ng-button>

        </ng-container>

        <!-- conteudo do box -->
        <ng-container class="ng-box-content">

          <!-- inicio da tabela -->
          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()"  *ngIf="!isSpinnerLoading">

                <tr *ngFor="let club of objects;index" ngChangeColorOnHover>

                     <td> <strong [ngStyle]="{fontSize: 'large',color:club.color}">{{club?.name}}</strong></td>

                    <td>
                      {{club?.email}}
                    </td>
                    <td>
                      {{club?.phone}}
                    </td>
                    <td>
                       {{club?.city?.name}}
                    </td>
                    <td>
                      {{club?.address}}
                    </td>

                    <ng-actions-table-bar>
                      <ng-button
                        *ngIf="isAdminOrUserKhuzela()"
                        title="Editar"
                        (click)="edit(club)"
                        [button]="{faIconClass:'fa fa-edit',color:'danger'}"
                      ></ng-button>
                      <ng-button
                        *ngIf="isAll()"
                        title="Detalhe"
                        (click)="detail(club)"
                        [button]="{faIconClass:'fa fa-eye',color:'danger'}"
                      ></ng-button>
                      <ng-button
                        *ngIf="isAdmin()"
                        title="Excluir"
                        (click)="delete(club)"
                        [button]="{faIconClass:'fa fa-close',color:'danger'}"
                      ></ng-button>
                    </ng-actions-table-bar>
                </tr>

          </ng-table>

            <!-- fim da tabela -->
            <ng-box-table-spinner class="overlay" *ngIf="isSpinnerLoading"></ng-box-table-spinner>

        </ng-container>

        <!-- fim do conteudo do box -->

      </ng-box>
      <!-- fim do box -->

    </div>
  </div>
</section>
